var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95087 9.41985L13.1086 12.5776C13.2553 12.7242 13.2553 12.962 13.1086 13.1087C12.962 13.2553 12.7242 13.2553 12.5775 13.1087L9.41977 9.95094L9.95087 9.41985Z",
    stroke: "#414141",
    strokeWidth: 0.885
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93083 11.8615C2.65532 11.8615 0 9.20621 0 5.93075C0 2.65529 2.65532 0 5.93083 0C9.20634 0 11.8617 2.65529 11.8617 5.93075C11.8617 9.20621 9.20634 11.8615 5.93083 11.8615Z",
    fill: "#414141"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.93081 10.6341C8.52863 10.6341 10.6346 8.52816 10.6346 5.93038C10.6346 3.3326 8.52863 1.22668 5.93081 1.22668C3.333 1.22668 1.22705 3.3326 1.22705 5.93038C1.22705 8.52816 3.333 10.6341 5.93081 10.6341Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.90151c42c3278956ce16a5783aa867f1.svg";
export { ForwardRef as ReactComponent };